export default __webpack_public_path__ + "static/media/mTop_2_p1.559f41f2.jpeg";